














































import { Component, Prop, Vue } from "vue-property-decorator";
import FullRouteCityList from "@/components/tabs/route_info/full-route-city-list.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";

import { routeInfo } from "@/config/host.config";
import { IRouteCity } from "@/@types/routeInfo/route-info";

@Component({
  components: { FullRouteCityList, BSwitch },
})
export default class CityList extends Vue {
  @Prop({ type: Array, default: () => [] }) cityList!: Array<IRouteCity>;
  @Prop({ type: String, default: "" }) activeRoute!: string;
  @Prop({ type: Boolean, default: false }) config!: boolean;

  errorNoty(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }

  async copyCity(id: string): Promise<void> {
    if (!this.config) return;
    const city = this.cityList.find((el) => el._id == id);
    if (!city) {
      this.errorNoty();
      return;
    }
    const uri = routeInfo.copy;
    try {
      const copy = await this.$axios.post(uri, city);
      if (copy.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        return;
      }
      this.errorNoty();
    } catch (error) {
      console.log(error);
      this.errorNoty();
    }
  }
}
